import { Box } from "@mui/material";
import { useMember } from "api/members";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import "react-loading-skeleton/dist/skeleton.css";
import { Outlet, useParams } from "react-router-dom";
import { links } from "utilities/links";
import { UserProfileBar } from "./UserProfileBar";

export function SingleMemberParent() {
  const { message } = useMessage();
  const { id: memberID } = useParams<{ id: string; page: string }>();

  const { useMembersData } = useMember(memberID);
  const { data: membersData } = useMembersData();

  const isMemberAnonymized = membersData?.anonymized;
  const memberName = isMemberAnonymized
    ? message({ id: "anonymizedProfile" })
    : `${membersData?.firstName} ${membersData?.lastName}`;

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "members" }),
      path: links.membersList,
    },
  };

  return (
    <>
      <TopHeader
        title={membersData ? memberName : ""}
        clearLink={links.membersList}
        breadcrumbs={breadcrumbs}
        data-hj-suppress
      />
      <UserProfileBar membersData={membersData} />
      <Outlet />
      <Box pt={8} />
    </>
  );
}
